/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { isIOS } from 'react-device-detect';
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from 'react-simple-captcha';
import CaptchaTest from './RenderCaptcha';

export interface IContactDatumProps {
  type: 'address' | 'phone' | 'email' | 'open-hours';
  label: string;
  value: string[];
}

export interface IContactProps {
  contactSectionId?: string;
  contactLabel?: string;
  contactDescription?: string;
  contactFormAppId?: string;
  contactFormAction?: string;
  contactData?: IContactDatumProps[];
  onContact?(
    name: string,
    email: string,
    subject: string,
    message: string
  ): void;
  contactPostUrl?: string;
}

export const Contact = ({
  contactSectionId,
  contactLabel,
  contactDescription,
  contactData,
  contactFormAppId,
  contactFormAction,
  onContact,
  contactPostUrl,
}: IContactProps) => {
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);
  const [errors, setErrors] = React.useState({});

  const handleValidation = () => {
    let formIsValid = true;
    let _errors = { ...errors };

    if (typeof nameRef?.current?.value !== 'undefined') {
      if (!nameRef?.current?.value.match(/^[a-zA-Z_ ]+$/)) {
        formIsValid = false;
        _errors.name = 'name should contain only letters';
      } else if (_errors?.name) {
        delete _errors['name'];
      }
    }

    if (typeof emailRef?.current?.value !== 'undefined') {
      if (!emailRef?.current?.value.match(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}/)) {
        formIsValid = false;
        _errors.email = 'please enter valid email address';
      } else if (_errors?.email) {
        delete _errors['email'];
      }
    }

    if (typeof subjectRef?.current?.value !== 'undefined') {
      if (!subjectRef?.current?.value.match(/^[a-zA-Z_ ]+$/)) {
        formIsValid = false;
        _errors.subject = 'should contain only letters';
      } else if (_errors?.subject) {
        delete _errors['subject'];
      }
    }

    if (typeof messageRef?.current?.value !== 'undefined') {
      if (!messageRef?.current?.value.match(/^[a-zA-Z0-9_ ,\.\']*$/)) {
        formIsValid = false;
        _errors.message = 'should contain only letters';
      } else if (_errors?.message) {
        delete _errors['message'];
      }
    }

    setErrors(_errors);

    return formIsValid;
  };

  console.log(`error bla: `, errors);

  const _onFormSubmit = (event: any) => {
    event.preventDefault();
    console.log(`_onFormSubmit`, event);
    let user_captcha = document.getElementById('user_captcha_input').value;
    console.log(`user_captcha`, user_captcha);
    if (handleValidation()) {
      if (validateCaptcha(user_captcha) === true) {
        loadCaptchaEnginge(6);
        document.getElementById('user_captcha_input').value = '';
        if (event) {
          event.preventDefault();
          if (onContact) {
            onContact(
              nameRef?.current?.value,
              emailRef?.current?.value,
              subjectRef?.current?.value,
              messageRef?.current?.value
            );
          }
          if (contactPostUrl) {
            axios
              .post(contactPostUrl, {
                name: nameRef?.current?.value,
                email: emailRef?.current?.value,
                subject: subjectRef?.current?.value,
                message: messageRef?.current?.value,
                fromUrl: window.location.origin,
                appId: contactFormAppId,
                action: contactFormAction,
              })
              .then((res) => {
                console.log('post success', res?.data);
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  text: 'Your message is sent successfully',
                  showConfirmButton: false,
                  timer: 3000,
                });
              })
              .catch((error) => {
                console.log('post failure', error?.message);
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  text: 'Your message is failed to send, Please try again !',
                  showConfirmButton: false,
                  timer: 3000,
                });
              });
          }
          // 👇️ clear all input values in the form
          event.target.reset();
        }
      } else {
        alert('Captcha Does Not Match');
        document.getElementById('user_captcha_input').value = '';
        if (event) {
          event.preventDefault();
          if (onContact) {
            onContact(
              nameRef?.current?.value,
              emailRef?.current?.value,
              subjectRef?.current?.value,
              messageRef?.current?.value
            );
          }
          event.target.reset();
        }
      }
    }
  };

  const _renderHeader = () => {
    if (contactDescription) {
      return (
        <header className='section-header'>
          <h2>{contactLabel}</h2>
          <p>{contactDescription}</p>
        </header>
      );
    }
  };
  const _renderContactValue = (value?: string[]) => {
    let _comp: any = [];
    if (value) {
      value?.forEach((val, index) => {
        _comp.push(
          <React.Fragment key={`contact-value-${index}`}>
            <p>{val}</p>
          </React.Fragment>
        );
      });
    }
    return _comp;
  };
  const _renderContactInfo = (contact: IContactDatumProps, index: number) => {
    let _comp: any = [];
    if (contact) {
      if (contact.type === 'address') {
        _comp.push(
          <div key={`contact-info-box-${index}`} className={'info-box'}>
            <i className='bi bi-geo-alt' />
            <h3>{contact.label}</h3>
            {_renderContactValue(contact?.value)}
          </div>
        );
      } else if (contact.type === 'phone') {
        _comp.push(
          <div key={`contact-info-box-${index}`} className={'info-box'}>
            <i className='bi bi-telephone' />
            <h3>{contact.label}</h3>
            {_renderContactValue(contact?.value)}
          </div>
        );
      } else if (contact.type === 'email') {
        _comp.push(
          <div key={`contact-info-box-${index}`} className={'info-box'}>
            <i className='bi bi-envelope' />
            <h3>{contact.label}</h3>
            {_renderContactValue(contact?.value)}
          </div>
        );
      } else if (contact.type === 'open-hours') {
        _comp.push(
          <div key={`contact-info-box-${index}`} className={'info-box'}>
            <i className='bi bi-clock' />
            <h3>{contact.label}</h3>
            {_renderContactValue(contact?.value)}
          </div>
        );
      } else {
      }
    }
    return _comp;
  };

  const _renderContact = () => {
    let _comp: any = [];
    if (contactData) {
      contactData?.forEach((_contact, index) => {
        _comp.push(
          <div key={`contact-info-${index}`} className={'col-md-6'}>
            {_renderContactInfo(_contact, index)}
          </div>
        );
      });
    }
    return _comp;
  };
  let _aos_props: any = {};
  if (!isIOS) {
    _aos_props = {
      'data-aos': 'fade-up',
    };
  }
  return (
    <section id={contactSectionId} className='contact'>
      <div className='container' {..._aos_props}>
        {_renderHeader()}
        <div className='row gy-4'>
          <div className='col-lg-6'>
            <div className='row gy-4'>{_renderContact()}</div>
          </div>

          <div className='col-lg-6'>
            <form
              method='post'
              className='php-email-form'
              onSubmit={_onFormSubmit}
            >
              <div className='row gy-4'>
                <div className='col-md-6'>
                  <input
                    type='text'
                    name='name'
                    className='form-control'
                    placeholder='Your Name'
                    required
                    ref={nameRef}
                  />
                  <span
                    style={{ color: 'red', fontSize: '12px', fontWeight: 600 }}
                  >
                    {errors?.name}
                  </span>
                </div>

                <div className='col-md-6 '>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    placeholder='Your Email'
                    required
                    ref={emailRef}
                  />
                  <span
                    style={{ color: 'red', fontSize: '12px', fontWeight: 600 }}
                  >
                    {errors?.email}
                  </span>
                </div>

                <div className='col-md-12'>
                  <input
                    type='text'
                    className='form-control'
                    name='subject'
                    placeholder='Subject'
                    required
                    ref={subjectRef}
                  />
                  <span
                    style={{ color: 'red', fontSize: '12px', fontWeight: 600 }}
                  >
                    {errors?.subject}
                  </span>
                </div>

                <div className='col-md-12'>
                  <textarea
                    className='form-control'
                    name='message'
                    rows='6'
                    placeholder='Message'
                    required
                    ref={messageRef}
                  />
                  <span
                    style={{ color: 'red', fontSize: '12px', fontWeight: 600 }}
                  >
                    {errors?.message}
                  </span>
                </div>
                <CaptchaTest />
                <div className='col-md-12 text-center'>
                  <div className='loading'>Loading</div>
                  <div className='error-message' />
                  <div className='sent-message'>
                    Your message has been sent. Thank you!
                  </div>

                  <button type='submit'>Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

Contact.defaultProps = {
  contactSectionId: 'contact',
  contactLabel: 'Contact',
  contactDescription: 'Contact Us',
};
